<template>
  <div class="resume-manage-container">
    <LoginButton />

    <div class="main-content">
      <div class="sidebar">
        <div class="sidebar-header">
          <div class="sidebar-header-title">简历管理</div>

          <div class="mine-resume">
            <div class="mine-resume-title">我的简历</div>
          </div>
        </div>
      </div>

      <!-- 简历分类 -->
      <div class="resume-category" v-if="!resumeDetailShow">

        <!-- 分类列表 -->
        <div class="category-list">
          <div class="category-item" v-for="(group, categoryId) in groupedResumes" :key="categoryId">
            <div class="category-header">
              <div class="name" @click="handleEditCategory(categoryId, group.category.name)">{{ group.category.name }}
              </div>
              <i class="el-icon-close delete-icon" @click="deleteCategory(categoryId)"></i>
              <div class="line"></div>
            </div>
            <div class="resume-list">
              <div class="resume-item" v-for="resume in group.resumes" :key="resume.id">
                <div class="item-header">
                  <div class="name">{{ resume.resume_name || '简历名称' }}</div>
                  <img @click="previewResume(resume)" class="preview-icon" src="../assets/img/edit.png" alt="">
                </div>
                <div class="item-content">
                  <div class="time">{{ resume.update_time?.split('T')[1] || '--' }}</div>
                  <div class="date">{{ resume.update_time?.split('T')[0] || '--' }}</div>
                  <div class="item-content-bottom">
                    <div class="tags">
                      <div class="tag" v-for="(label, index) in getLabel(resume.label)"
                        :key="`resume-label-${resume.id}-${index}`">{{ label }}</div>
                    </div>
                    <div class="action">
                      <img @click="deleteResume(resume.id)" class="delete-icon" src="../assets/img/delete.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-button">
          <button @click="handleAddCategory" class="add-category">
            <span>新增分类</span>
          </button>
          <button @click="handleAddResume" class="add-resume">
            <span>新建简历</span>
          </button>
          <button class="back">
            <span>返回</span>
          </button>
        </div>

        <!-- 新增分类 -->
        <el-dialog :visible="addCategoryDialog" :title="addCategoryForm.id ? '编辑分类' : '新增分类'" width="25%"
          @close="handleCancelCategory">
          <el-form :model="addCategoryForm" ref="addCategoryFormRef" :rules="addCategoryFormRules" label-width="100px">
            <el-form-item label="分类名称" prop="name">
              <el-input clearable v-model="addCategoryForm.name" placeholder="请输入分类名称" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleCancelCategory">取消</el-button>
            <el-button size="small" type="primary" @click="handleAddCategorySave">确定</el-button>
          </div>
        </el-dialog>

        <!-- 新建简历 -->
        <el-dialog :visible="addResumeDialog" title="新建简历" width="25%" @close="addResumeDialog = false">
          <div class="add-resume-btn-container">
            <button class="add-resume-btn" @click="addBlankResumeDialog = true">
              <span>新建空白简历</span>
            </button>
            <button class="add-resume-btn" @click="selectResumeDialog = true">
              <span>选择已有简历</span>
            </button>
          </div>

          <el-dialog :visible="addBlankResumeDialog" append-to-body title="新建简历" width="25%"
            @close="handleCancelAddBlankResume">
            <el-form :model="addResumeForm" ref="addResumeFormRef" :rules="addResumeFormRules" label-width="100px">
              <el-form-item label="选择分类" prop="category_id">
                <el-select class="w100" v-model="addResumeForm.category_id" placeholder="请选择分类">
                  <el-option v-for="item in resumeCategory" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="handleCancelAddBlankResume">取消</el-button>
              <el-button size="small" type="primary" @click="handleAddBlankResumeSave">确定</el-button>
            </div>
          </el-dialog>

          <!-- 选择已有简历 -->
          <el-dialog :visible="selectResumeDialog" append-to-body title="选择已有简历" width="60%"
            @close="selectResumeDialog = false">
            <div class="select-resume-dialog-content">
              <div class="category-list">
                <div class="category-item" v-for="(group, categoryId) in groupedResumes" :key="categoryId">
                  <div class="category-header">
                    <div class="name">{{
                      group.category.name }}
                    </div>
                    <div class="line"></div>
                  </div>
                  <div class="resume-list">
                    <div class="resume-item" @click="handleSelectResume(resume)" v-for="resume in group.resumes"
                      :key="resume.id">
                      <div class="item-header">
                        <div class="name">{{ resume.resume_name || '简历名称' }}</div>
                      </div>
                      <div class="item-content">
                        <div class="time">{{ resume.update_time?.split('T')[1] || '--' }}</div>
                        <div class="date">{{ resume.update_time?.split('T')[0] || '--' }}</div>
                        <div class="item-content-bottom">
                          <div class="tags">
                            <div class="tag" v-for="(label, index) in getLabel(resume.label)"
                              :key="`resume-label-${resume.id}-${index}`">{{ label }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
        </el-dialog>
      </div>

      <!-- 简历详情 -->
      <div class="resume-content" v-else>
        <div class="resume-content-box">
          <div class="resume-header">
            <div class="title" @click="handleResumeEdit('resume_name')">{{ resumeDetail.resume_name || '简历名称' }}</div>
            <div class="tags-container">
              <div class="tags">
                <div class="label">简历类别：</div>
                <div class="value" @click="handleResumeEdit('category_id')">{{ resumeDetail.category_name }}</div>
              </div>
              <div class="tags">
                <div class="label">简历标签：</div>
                <div class="tags-value">
                  <div class="tag" @click="handleResumeEdit('label')"
                    v-for="(label, index) in getLabel(resumeDetail.label)" :key="`label-${index}`">{{
                      label }}</div>
                  <div class="tag" @click="handleResumeEdit('label')" v-if="!resumeDetail.label">标签</div>
                </div>
              </div>
            </div>
            <ResumeHeaderDialog :category-options="resumeCategory" ref="resumeHeaderDialog" />
          </div>
          <div class="line"></div>

          <div class="resume-wrap">

            <!-- 用户信息 -->
            <div id="userinfo" class="resume-item resume-user-info">
              <div class="avatar">
                <img src="https://sxsimg.xiaoyuanzhao.com/edu/user_default2.png" alt="">
              </div>
              <div class="user-info" v-if="!basicInfoEdit">
                <div class="name-gender">
                  <div class="name">{{ resumeDetail.name }}</div>
                  <img class="gender" :style="{ transform: resumeDetail.sex === 1 ? 'rotate(-45deg)' : '' }"
                    src="../assets/img/female.png" alt="">
                </div>
                <div class="info-flex">
                  <span class="prev-line" v-if="resumeDetail.age">年龄：{{ resumeDetail.age }}</span>
                  <span class="prev-line" v-if="resumeDetail.base_city">地址：{{ resumeDetail.base_city }}</span>
                  <span class="prev-line" v-if="resumeDetail.education">学历：{{ education[resumeDetail.education]
                  }}</span>
                  <span class="prev-line" v-if="resumeDetail.arrival_time">到岗时间：{{
                    arrival_time[resumeDetail.arrival_time] }}</span>
                  <span class="prev-line" v-if="resumeDetail.phone">电话：{{ resumeDetail.phone }}</span>
                  <span class="prev-line" v-if="resumeDetail.email">邮箱：{{ resumeDetail.email }}</span>
                </div>
                <div class="action" @click="handleBasicInfoEdit">
                  编辑
                </div>
              </div>

              <div class="resume-user-info-edit" v-else>
                <el-form :model="basicInfoForm" ref="basicInfoFormRef" :rules="basicInfoFormRules" label-width="100px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="姓名" prop="name">
                        <el-input class="w100" v-model="basicInfoForm.name" placeholder="请输入姓名" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="性别" prop="sex">
                        <el-select class="w100" v-model="basicInfoForm.sex" placeholder="请选择性别">
                          <el-option label="男" :value="1" />
                          <el-option label="女" :value="2" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="年龄" prop="age">
                        <el-input class="w100" v-model="basicInfoForm.age" placeholder="请输入年龄" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地址" prop="base_city">
                        <el-input class="w100" v-model="basicInfoForm.base_city" placeholder="请输入地址" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电话" prop="phone">
                        <el-input class="w100" v-model="basicInfoForm.phone" placeholder="请输入电话" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮箱" prop="email">
                        <el-input class="w100" v-model="basicInfoForm.email" placeholder="请输入邮箱" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="学历" prop="education">
                        <el-select class="w100" v-model="basicInfoForm.education" placeholder="请选择学历">
                          <el-option v-for="(item, index) in education" :key="index" :label="item" :value="index" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div class="edit-footer">
                    <el-button size="small" class="cancel-btn" @click="handleCancel">取消</el-button>
                    <el-button size="small" class="save-btn" type="primary" @click="handleSave">保存</el-button>
                  </div>
                </el-form>
              </div>
            </div>

            <!-- 教育经历 -->
            <div id="education">
              <Education :data-list="resumeDetail.education_experience || []" @save="handleEducationSave"
                @delete="handleEducationDelete" />
            </div>

            <!-- 求职偏好 -->
            <div id="preference" class="preference">
              <div class="preference-title">
                <div class="m-l">
                  <img class="icon" src="../assets/img/bookmark-one.png" alt="">
                  <div class="title">求职偏好</div>
                </div>
                <div class="m-r">
                  <img @click="handlePreference" class="add-icon" src="../assets/img/edit.png" alt="">
                </div>
              </div>

              <!-- 求职偏好数据 -->
              <div class="preference-data-wrap" v-if="!preferenceShow && resumeDetail.desired_position">
                <div style="margin-top: 16px;" class="preference-name">{{ resumeDetail.desired_position }}</div>
                <div class="preference-data-item">
                  <div>期望行业：{{ resumeDetail.desired_industry }}</div>
                  <div class="line"></div>
                  <div>期望城市：{{ resumeDetail.desired_city }}</div>
                </div>
                <div class="preference-data-item">
                  <div>求职性质：{{ ['全职', '兼职', '实习', '自由职业'][resumeDetail.work_nature] }}</div>
                  <div class="line" v-if="resumeDetail.work_nature !== 1"></div>
                  <div v-if="resumeDetail.work_nature !== 1">实习时长：{{ ['3个月以内', '3到6个月',
                    '6个月以上'][resumeDetail.internship_duration] }}</div>
                  <div class="line" v-if="resumeDetail.work_nature !== 1"></div>
                  <div v-if="resumeDetail.work_nature !== 1">每周出勤天数：{{ resumeDetail.weekly_attendance_days }}</div>
                  <div class="line" v-if="resumeDetail.work_nature !== 1"></div>
                  <div>到岗时间：{{ ['随时到岗', '1周内', '2周内', '1个月内', '3个月内'][resumeDetail.arrival_time] }}</div>
                </div>
                <div class="delete-icon" @click="handleDeletePreference">
                  <img src="../assets/img/delete.png" alt="">
                </div>
              </div>

              <!-- 求职偏好编辑 -->
              <div class="preference-form" v-if="preferenceShow">
                <div class="preference-form-title">求职偏好</div>
                <el-form :model="preferenceForm" ref="preferenceFormRef" :rules="preferenceFormRules"
                  label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="期望职位" prop="desired_position">
                        <el-input clearable class="w100" v-model="preferenceForm.desired_position"
                          placeholder="请输入期望职位" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望行业" prop="desired_industry">
                        <el-input clearable class="w100" v-model="preferenceForm.desired_industry"
                          placeholder="请输入期望行业" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望城市" prop="desired_city">
                        <el-input clearable class="w100" v-model="preferenceForm.desired_city"
                          placeholder="请输入期望城市" />
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="工作性质" prop="work_nature">
                        <el-select @change="handleWorkNatureChange" class="w100" v-model="preferenceForm.work_nature"
                          placeholder="请选择工作性质">
                          <el-option label="未知" :value="0" />
                          <el-option label="全职" :value="1" />
                          <el-option label="兼职" :value="2" />
                          <el-option label="实习" :value="3" />
                          <el-option label="自由职业" :value="4" />
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="到岗时间" prop="arrival_time">
                        <el-select class="w100" v-model="preferenceForm.arrival_time" placeholder="请选择到岗时间">
                          <el-option label="随时到岗" :value="0" />
                          <el-option label="1周内" :value="1" />
                          <el-option label="2周内" :value="2" />
                          <el-option label="1个月内" :value="3" />
                          <el-option label="3个月内" :value="4" />
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" v-if="preferenceForm.work_nature !== 1">
                      <el-form-item label="实习时长" prop="internship_duration">
                        <el-select class="w100" v-model="preferenceForm.internship_duration" placeholder="请选择实习时长">
                          <el-option label="3个月以内" :value="0" />
                          <el-option label="3到6个月" :value="1" />
                          <el-option label="6个月以上" :value="2" />
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" v-if="preferenceForm.work_nature !== 1">
                      <el-form-item label="每周出勤天数" prop="weekly_attendance_days">
                        <el-input type="number" min="0" max="7" clearable class="w100"
                          v-model="preferenceForm.weekly_attendance_days" placeholder="请输入每周出勤天数" />
                      </el-form-item>
                    </el-col>

                  </el-row>
                </el-form>
                <div class="preference-form-footer">
                  <el-button size="small" class="cancel-btn" @click="handleCancelPreference">取消</el-button>
                  <el-button size="small" class="save-btn" type="primary" @click="handleSavePreference">保存</el-button>
                </div>
              </div>
            </div>

            <!-- 社团和组织经历 -->
            <div id="organization">
              <Organization :data-list="resumeDetail.organization_experience || []" @save="handleOrganizationSave"
                @delete="handleOrganizationDelete" />
            </div>

            <!-- 实习经历 -->
            <div id="internship">
              <Internship :data-list="resumeDetail.internship_experience || []" @save="handleInternshipSave"
                @delete="handleInternshipDelete" />
            </div>

            <!-- 学术经历 -->
            <div id="academic">
              <Academic :data-list="resumeDetail.academic_experience || []" @save="handleAcademicSave"
                @delete="handleAcademicDelete" />
            </div>

            <!-- 获奖经历 -->
            <div id="award">
              <Award :data-list="resumeDetail.award_experience || []" @save="handleAwardSave"
                @delete="handleAwardDelete" />
            </div>

            <!-- 技能语言 -->
            <div id="skill">
              <Skill :data-list="resumeDetail.skill_language || []" @save="handleSkillSave"
                @delete="handleSkillDelete" />
            </div>

            <!-- 个人总结 -->
            <div id="summary" class="summary">
              <div class="summary-title">
                <div class="m-l">
                  <img class="icon" src="../assets/img/bookmark-one.png" alt="">
                  <div class="title">个人总结</div>
                </div>
                <div class="m-r">
                  <img @click="handleSummary" class="add-icon" src="../assets/img/edit.png" alt="">
                </div>
              </div>

              <div class="summary-data-wrap" v-if="!summaryShow && resumeDetail.personal_summary">
                <div class="summary-content">{{ resumeDetail.personal_summary }}</div>
              </div>

              <div class="summary-form" v-if="summaryShow">
                <div class="summary-form-title">个人总结</div>
                <el-form :model="summaryForm" ref="summaryFormRef" :rules="summaryFormRules" label-width="120px">
                  <el-form-item label="个人总结" prop="personal_summary">
                    <el-input type="textarea" class="w100" :rows="4" v-model="summaryForm.personal_summary"
                      placeholder="请输入个人总结" />
                  </el-form-item>
                </el-form>
                <div class="summary-form-footer">
                  <el-button size="small" class="cancel-btn" @click="handleCancelSummary">取消</el-button>
                  <el-button size="small" class="save-btn" type="primary" @click="handleSaveSummary">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="resume-sider">
          <div class="resume-sider-box online-resume">
            <div class="resume-sider-header">
              <div class="title">在线简历</div>
            </div>

            <div class="resume-module">
              <div class="resume-module-item" @click="scrollToSection('userinfo')">基础信息</div>
              <div class="resume-module-item" @click="scrollToSection('education')">教育经历</div>
              <div class="resume-module-item" @click="scrollToSection('preference')">求职偏好</div>
              <div class="resume-module-line"></div>
              <div class="resume-module-item" @click="scrollToSection('organization')">社团和组织经历</div>
              <div class="resume-module-item" @click="scrollToSection('internship')">实习经历</div>
              <div class="resume-module-item" @click="scrollToSection('academic')">学术经历</div>
              <div class="resume-module-line"></div>
              <div class="resume-module-item" @click="scrollToSection('award')">获奖经历</div>
              <div class="resume-module-item" @click="scrollToSection('skill')">技能/语言</div>
              <div class="resume-module-item" @click="scrollToSection('summary')">个人总结</div>
            </div>
          </div>
          <div class="resume-sider-box annex-resume">
            <div class="resume-sider-header">
              <div class="title">附件简历</div>
              <div class="action">上传</div>
            </div>

            <div class="annex-resume-list">
              <div class="annex-resume-item">
                <div class="item-name">
                  <img src="../assets/img/Link.png" alt="">
                  <div class="name-text">简历-文件名XX.pdf</div>
                </div>
                <i class="el-icon-close close-icon"></i>
              </div>
              <div class="annex-resume-item">
                <div class="item-name">
                  <img src="../assets/img/Link.png" alt="">
                  <div class="name-text">简历-文件名XX.pdf</div>
                </div>
                <i class="el-icon-close close-icon"></i>
              </div>
            </div>
          </div>

          <div class="action-button">
            <button class="save-button" @click="goBack">
              <span>返回</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { addResumeToBaseResume, addResume, addResumeCategory, updateResumeCategory, deleteResumeCategory, addResumeBasicInfo, getResumeList, getResumeCategory, deleteResume, addResumeEducationExperience, addResumeOrganizationExperience, addResumeInternshipExperience, addResumeAcademicExperience, addResumeAwardExperience, addResumeSkillLanguage } from '@/api/resume'
import ResumeHeaderDialog from './components/resume-header-dialog.vue'
import Education from './components/education.vue'
import Organization from './components/organization.vue'
import Internship from './components/internship.vue'
import Academic from './components/academic.vue'
import Award from './components/award.vue'
import Skill from './components/skill.vue'

export default {
  name: 'ResumeManage',
  components: {
    ResumeHeaderDialog,
    Education,
    Organization,
    Internship,
    Academic,
    Award,
    Skill,
  },
  data() {
    return {
      // 学历和到岗时间映射
      education: ['未知', '初中', '高中', '大专', '本科', '硕士', '博士'],
      arrival_time: ['随时到岗', '1周内', '2周内', '1个月内', '3个月内'],

      query: {
        page_no: 1,
        page_size: 20,
      },
      resumeList: [],
      resumeCategory: [],
      addCategoryDialog: false,
      addCategoryForm: {
        name: '',
      },
      addResumeDialog: false,
      addBlankResumeDialog: false,
      addResumeForm: {
        category_id: '',
      },
      addResumeFormRules: {
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
      },
      addCategoryFormRules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
      },
      resumeDetail: {},
      resumeDetailShow: false,
      basicInfoEdit: false,
      basicInfoForm: {
        id: '',
        name: '',
        sex: 1,
        age: '',
        base_city: '',
        phone: '',
        email: '',
        education: '',
      },
      basicInfoFormRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        base_city: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        education: [{ required: true, message: '请选择学历', trigger: 'blur' }],
      },
      // 求职偏好编辑
      preferenceShow: false,
      preferenceForm: {
        id: '',
        desired_position: '',
        desired_industry: '',
        work_nature: '',
        arrival_time: '',
        internship_duration: '',
        weekly_attendance_days: '',
        desired_city: ''
      },
      preferenceFormRules: {
        desired_position: [{ required: true, message: '请输入期望职位', trigger: 'blur' }],
        desired_industry: [{ required: true, message: '请输入期望行业', trigger: 'blur' }],
        work_nature: [{ required: true, message: '请选择工作性质', trigger: 'change' }],
        arrival_time: [{ required: true, message: '请选择到岗时间', trigger: 'change' }],
        internship_duration: [{ required: true, message: '请选择实习时长', trigger: 'change' }],
        weekly_attendance_days: [{ required: true, message: '请输入每周出勤天数', trigger: 'blur' }],
        desired_city: [{ required: true, message: '请输入期望城市', trigger: 'blur' }],
      },
      // 个人总结编辑
      summaryShow: false,
      summaryForm: {
        id: '',
        personal_summary: '',
      },
      summaryFormRules: {
        personal_summary: [{ required: true, message: '请输入个人总结', trigger: 'blur' }],
      },
      selectResumeDialog: false,
    };
  },
  computed: {
    // 合并后的简历数据，每个简历都包含分类信息
    mergedResumeList() {
      if (!Array.isArray(this.resumeList) || !Array.isArray(this.resumeCategory)) {
        return []
      }

      return this.resumeList.map(resume => {
        const category = this.resumeCategory.find(cat => cat.id === resume.category_id)
        return {
          ...resume,
          categoryName: category ? category.name : '未分类'
        }
      })
    },

    // 按分类分组的简历数据
    groupedResumes() {
      if (!Array.isArray(this.resumeCategory) || !Array.isArray(this.resumeList)) {
        return {}
      }

      const grouped = {}

      this.resumeCategory.forEach(category => {
        grouped[category.id] = {
          category: category,
          resumes: this.resumeList.filter(resume => resume.category_id === category.id)
        }
      })

      // // 处理未分类的简历
      // const uncategorizedResumes = this.resumeList.filter(resume =>
      //   !this.resumeCategory.find(cat => cat.id === resume.category_id)
      // )

      // if (uncategorizedResumes.length > 0) {
      //   grouped['uncategorized'] = {
      //     category: { id: 'uncategorized', name: '未分类' },
      //     resumes: uncategorizedResumes
      //   }
      // }

      return grouped
    },


  },
  mounted() {
    this.getResumeCategory()
    this.getResumeList()
  },
  methods: {

    handleMenuSelect(item) {
      console.log('点击了菜单项:', item)
    },
    getLabel(label) {
      if (label) {
        // 分割标签
        const labels = label.split(',')
        return labels.filter(item => item.trim()) // 只去除空值，不去重
      }
      return []
    },
    async getResumeList() {
      const res = await getResumeList(this.query)
      this.resumeList = res.data.data.lists
      // 如果当前正在查看简历详情，需要同步更新resumeDetail
      if (this.resumeDetail.id) {
        const updatedResume = this.resumeList.find(item => item.id === this.resumeDetail.id)
        if (updatedResume) {
          this.resumeDetail = {
            ...updatedResume,
            category_name: this.getCategoryName(updatedResume.category_id)
          }
        }
      }
    },
    async getResumeCategory() {
      const res = await getResumeCategory()
      this.resumeCategory = res.data.data.lists
    },

    // 根据分类ID获取分类名称
    getCategoryName(categoryId) {
      const category = this.resumeCategory.find(cat => cat.id === categoryId)
      return category ? category.name : '未分类'
    },

    // 获取指定分类下的所有简历
    getResumesByCategory(categoryId) {
      return this.resumeList.filter(resume => resume.category_id === categoryId)
    },

    // 获取所有分类及其简历数量
    getCategoryStats() {
      return this.resumeCategory.map(category => ({
        ...category,
        resumeCount: this.getResumesByCategory(category.id).length
      }))
    },

    // 编辑分类
    handleEditCategory(categoryId, name) {
      console.log(categoryId, name);

      this.addCategoryDialog = true
      this.addCategoryForm = {
        id: categoryId,
        name: name,
      }
    },

    // 新建简历
    handleAddResume() {
      this.addResumeDialog = true
    },

    // 选择已有简历
    handleSelectResume(resume) {
      this.$confirm('确定选择该简历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addResumeToBaseResume(resume).then(res => {
          if (res.data.code === 1) {
            this.$message.success('生成简历成功')
            this.getResumeList()
            this.addResumeDialog = false
            this.selectResumeDialog = false
          } else {
            this.$message.error('生成简历失败')
          }
        })
        console.log(resume);
      }).catch(() => {
        console.log('取消')
      })
    },

    // 空白简历
    handleAddBlankResumeSave() {
      this.$refs.addResumeFormRef.validate((valid) => {
        if (valid) {
          console.log(this.addResumeForm)
          addResume(this.addResumeForm).then(res => {
            if (res.data.code === 1) {
              this.$message.success('新建简历成功')
              this.getResumeList()
              this.addBlankResumeDialog = false
              this.addResumeDialog = false
            } else {
              this.$message.error('新建简历失败')
            }
          })
        }
      })
    },

    // 取消空白简历
    handleCancelAddBlankResume() {
      this.addBlankResumeDialog = false
      this.addResumeForm = {
        category_id: '',
      }
      this.$nextTick(() => {
        this.$refs.addResumeFormRef.resetFields()
      })
    },

    // 新增分类
    handleAddCategory() {
      this.addCategoryDialog = true
    },

    // 取消新增分类
    handleCancelCategory() {
      this.addCategoryDialog = false
      this.addCategoryForm = {
        name: '',
      }
      this.$nextTick(() => {
        this.$refs.addCategoryFormRef.resetFields()
      })
    },

    // 新增分类保存
    handleAddCategorySave() {
      this.$refs.addCategoryFormRef.validate((valid) => {
        if (valid) {
          if (this.addCategoryForm.id) {
            updateResumeCategory(this.addCategoryForm).then(res => {
              if (res.data.code === 1) {
                this.$message.success('编辑分类成功')
                this.getResumeCategory()
                this.addCategoryDialog = false
              } else {
                this.$message.error('编辑分类失败')
              }
            })
          } else {
            addResumeCategory(this.addCategoryForm).then(res => {
              if (res.data.code === 1) {
                this.$message.success('新增分类成功')
                this.getResumeCategory()
                this.addCategoryDialog = false
              } else {
                this.$message.error('新增分类失败')
              }
            })
          }
        }
      })
    },

    // 删除分类
    deleteCategory(categoryId) {
      this.$confirm('确定删除该分类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteResumeCategory({ categoryId }).then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功')
            this.getResumeCategory()
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        console.log('取消')
      })
    },

    // 预览简历
    previewResume(row) {
      console.log(row);
      this.resumeDetail = { ...row, category_name: this.getCategoryName(row.category_id) }
      this.resumeDetailShow = true
    },

    // 返回
    goBack() {
      this.resumeDetailShow = false
      this.resumeDetail = {}
    },

    // 删除简历
    deleteResume(id) {
      this.$confirm('确定删除该简历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteResume({ resumeId: id }).then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功')
            this.getResumeList()
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        console.log('取消')
      })
    },

    // 滚动到指定区域
    scrollToSection(sectionId) {
      if (sectionId === 'userinfo') {
        // 如果是基础信息，直接滚动到页面最顶端
        const resumeContent = document.querySelector('.resume-content')
        if (resumeContent) {
          resumeContent.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      } else {
        // 其他模块滚动到对应区域
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      }
    },

    // 编辑头部信息
    handleResumeEdit(type) {
      this.$refs.resumeHeaderDialog.visible = true
      this.$refs.resumeHeaderDialog.title = type === 'resume_name' ? '编辑简历名称' : type === 'category_id' ? '编辑简历分类' : '编辑简历标签'
      this.$refs.resumeHeaderDialog.labelList = this.resumeDetail.label ? this.resumeDetail.label.split(',') : ['']
      this.$refs.resumeHeaderDialog.form = {
        id: this.resumeDetail.id,
        resume_name: this.resumeDetail.resume_name,
        category_id: this.resumeDetail.category_id,
        label: this.resumeDetail.label,
      }
    },

    // 编辑基础信息
    handleBasicInfoEdit() {
      this.basicInfoEdit = true
      this.basicInfoForm = {
        id: this.resumeDetail.id,
        name: this.resumeDetail.name,
        sex: this.resumeDetail.sex,
        age: this.resumeDetail.age,
        base_city: this.resumeDetail.base_city,
        phone: this.resumeDetail.phone,
        email: this.resumeDetail.email,
        education: this.resumeDetail.education,
      }
      this.$nextTick(() => {
        this.$refs.basicInfoFormRef.resetFields()
      })
    },

    // 取消编辑
    handleCancel() {
      this.$confirm('确定取消编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.basicInfoFormRef.resetFields()
        this.basicInfoEdit = false
        this.basicInfoForm = {
          name: '',
          sex: 1,
          age: '',
          base_city: '',
          phone: '',
          email: '',
          education: '',
        }
      }).catch(() => {
        console.log('取消')
      })
    },

    // 保存基础信息
    handleSave() {
      this.$refs.basicInfoFormRef.validate(async (valid) => {
        if (valid) {
          console.log(this.basicInfoForm)
          const result = await addResumeBasicInfo(this.basicInfoForm)
          if (result.data.code === 1) {
            this.$message.success('保存成功')
            this.getResumeList()
            this.basicInfoEdit = false
          } else {
            this.$message.error(result.data.msg || '保存失败')
          }
        } else {
          this.$message.error('保存失败')
        }
      })
    },

    // 保存教育经历
    async handleEducationSave(value) {
      try {
        // 处理学历显示
        const educationData = {
          ...value,
          degree: this.education[value.degree] || value.degree
        }

        let education_experiences = []
        if (value.id) {
          // 编辑模式
          education_experiences = this.resumeDetail.education_experience.map(item => {
            if (item.id === value.id) {
              return educationData
            }
            return item
          })
        } else {
          // 新增模式
          education_experiences = [
            ...this.resumeDetail.education_experience || [],
            educationData
          ]
        }

        // 调用API保存
        const result = await addResumeEducationExperience({
          resume_id: this.resumeDetail.id,
          education_experiences
        })

        if (result.data.code === 1) {
          this.$message.success(value.id ? '编辑成功' : '添加成功')
          await this.getResumeList()
        } else {
          this.$message.error(result.data.msg || '保存失败')
        }
      } catch (error) {
        this.$message.error('保存失败')
      }
    },

    // 删除教育经历
    async handleEducationDelete(id) {
      try {
        this.resumeDetail.education_experience = this.resumeDetail.education_experience.filter(item => item.id !== id)

        const result = await addResumeEducationExperience({
          resume_id: this.resumeDetail.id,
          education_experiences: this.resumeDetail.education_experience
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除教育经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    // 保存社团经历
    async handleOrganizationSave(value) {
      try {
        let organization_experiences = []
        if (value.id) {
          // 编辑模式
          organization_experiences = this.resumeDetail.organization_experience.map(item => {
            if (item.id === value.id) {
              return value
            }
            return item
          })
        } else {
          // 新增模式
          organization_experiences = [
            ...this.resumeDetail.organization_experience || [],
            value
          ]
        }

        // 调用API保存
        const result = await addResumeOrganizationExperience({
          resume_id: this.resumeDetail.id,
          organization_experiences
        })

        if (result.data.code === 1) {
          this.$message.success(value.id ? '编辑成功' : '添加成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error(result.data.msg || '保存失败')
        }
      } catch (error) {
        this.$message.error('保存失败')
      }
    },

    // 删除社团经历
    async handleOrganizationDelete(id) {
      try {
        this.resumeDetail.organization_experience = this.resumeDetail.organization_experience.filter(item => item.id !== id)

        const result = await addResumeOrganizationExperience({
          resume_id: this.resumeDetail.id,
          organization_experiences: this.resumeDetail.organization_experience
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除社团经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    // 保存实习经历
    async handleInternshipSave(value) {
      let internship_experiences = []
      try {
        if (value.id) {
          // 编辑模式
          internship_experiences = this.resumeDetail.internship_experience.map(item => {
            if (item.id === value.id) {
              return value
            }
            return item
          })
        } else {
          // 新增模式
          internship_experiences = [
            ...this.resumeDetail.internship_experience || [],
            value
          ]
        }
      } catch (error) {
        console.error('保存实习经历失败:', error)
        this.$message.error('保存失败')
      }
      const result = await addResumeInternshipExperience({
        resume_id: this.resumeDetail.id,
        internship_experiences
      })

      if (result.data.code === 1) {
        this.$message.success(value.id ? '编辑成功' : '添加成功')
        // 刷新数据 - 确保获取最新的数据
        await this.getResumeList()
      } else {
        this.$message.error(result.data.msg || '保存失败')
      }
    },

    // 删除实习经历
    async handleInternshipDelete(id) {
      try {
        this.resumeDetail.internship_experience = this.resumeDetail.internship_experience.filter(item => item.id !== id)

        const result = await addResumeInternshipExperience({
          resume_id: this.resumeDetail.id,
          internship_experiences: this.resumeDetail.internship_experience
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除实习经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    // 保存学术经历
    async handleAcademicSave(value, callback) {
      let academic_experiences = []
      try {
        if (value.id) {
          // 编辑模式
          academic_experiences = this.resumeDetail.academic_experience.map(item => {
            if (item.id === value.id) {
              return value
            }
            return item
          })
        } else {
          // 新增模式
          academic_experiences = [
            ...this.resumeDetail.academic_experience || [],
            value
          ]
        }
      } catch (error) {
        console.error('保存学术经历失败:', error)
        this.$message.error('保存失败')
      }
      const result = await addResumeAcademicExperience({
        resume_id: this.resumeDetail.id,
        academic_experiences
      })

      if (result.data.code === 1) {
        this.$message.success(value.id ? '编辑成功' : '添加成功')
        // 刷新数据 - 确保获取最新的数据
        await this.getResumeList()
      } else {
        this.$message.error(result.data.msg || '保存失败')
      }
    },

    // 删除学术经历
    async handleAcademicDelete(id) {
      try {
        this.resumeDetail.academic_experience = this.resumeDetail.academic_experience.filter(item => item.id !== id)

        const result = await addResumeAcademicExperience({
          resume_id: this.resumeDetail.id,
          academic_experiences: this.resumeDetail.academic_experience
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除学术经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    // 保存获奖经历
    async handleAwardSave(value, callback) {
      let award_experiences = []
      try {
        if (value.id) {
          // 编辑模式
          award_experiences = this.resumeDetail.award_experience.map(item => {
            if (item.id === value.id) {
              return value
            }
            return item
          })
        } else {
          // 新增模式
          award_experiences = [
            ...this.resumeDetail.award_experience || [],
            value
          ]
        }
      } catch (error) {
        console.error('保存获奖经历失败:', error)
        this.$message.error('保存失败')
      }
      const result = await addResumeAwardExperience({
        resume_id: this.resumeDetail.id,
        award_experiences
      })

      if (result.data.code === 1) {
        this.$message.success(value.id ? '编辑成功' : '添加成功')
        // 刷新数据 - 确保获取最新的数据
        await this.getResumeList()
      } else {
        this.$message.error(result.data.msg || '保存失败')
      }
    },

    // 删除获奖经历
    async handleAwardDelete(id) {
      try {
        this.resumeDetail.award_experience = this.resumeDetail.award_experience.filter(item => item.id !== id)

        const result = await addResumeAwardExperience({
          resume_id: this.resumeDetail.id,
          award_experiences: this.resumeDetail.award_experience
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除获奖经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    // 保存技能
    async handleSkillSave(value, callback) {
      let skill_languages = []
      try {
        if (value.id) {
          // 编辑模式
          skill_languages = this.resumeDetail.skill_language.map(item => {
            if (item.id === value.id) {
              return value
            }
            return item
          })
        } else {
          // 新增模式
          skill_languages = [
            ...this.resumeDetail.skill_language || [],
            value
          ]
        }
      } catch (error) {
        console.error('保存获奖经历失败:', error)
        this.$message.error('保存失败')
      }
      const result = await addResumeSkillLanguage({
        resume_id: this.resumeDetail.id,
        skill_languages
      })

      if (result.data.code === 1) {
        this.$message.success(value.id ? '编辑成功' : '添加成功')
        // 刷新数据 - 确保获取最新的数据
        await this.getResumeList()
      } else {
        this.$message.error(result.data.msg || '保存失败')
      }
    },

    // 删除技能
    async handleSkillDelete(id) {
      try {
        this.resumeDetail.skill_language = this.resumeDetail.skill_language.filter(item => item.id !== id)

        const result = await addResumeSkillLanguage({
          resume_id: this.resumeDetail.id,
          skill_languages: this.resumeDetail.skill_language
        })

        if (result.data.code === 1) {
          this.$message.success('删除成功')
          // 刷新数据 - 确保获取最新的数据
          await this.getResumeList()
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        console.error('删除获奖经历失败:', error)
        this.$message.error('删除失败')
      }
    },

    handlePreference() {
      this.preferenceShow = true
      this.preferenceForm = {
        id: this.resumeDetail.id,
        desired_position: this.resumeDetail.desired_position,
        desired_industry: this.resumeDetail.desired_industry,
        work_nature: this.resumeDetail.work_nature,
        internship_duration: this.resumeDetail.internship_duration,
        weekly_attendance_days: this.resumeDetail.weekly_attendance_days,
        arrival_time: this.resumeDetail.arrival_time,
        desired_city: this.resumeDetail.desired_city
      }

    },

    // 求职偏好新增 / 编辑
    handleCancelPreference() {
      this.$confirm('确定取消编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.preferenceForm = {
          id: this.resumeDetail.id,
          desired_position: '',
          desired_industry: '',
          work_nature: '',
          internship_duration: '',
          weekly_attendance_days: '',
          arrival_time: '',
          desired_city: ''
        }
        this.$refs.preferenceFormRef.resetFields()
        this.preferenceShow = false
      }).catch(() => {
        this.$message.info('已取消')
      })
    },

    handleSavePreference() {
      this.$refs.preferenceFormRef.validate(async (valid) => {
        if (valid) {
          // await this.handleSavePreference()
          console.log(this.preferenceForm)
          addResumeBasicInfo(this.preferenceForm).then(async res => {
            if (res.data.code === 1) {
              this.$message.success('保存成功')
              this.preferenceShow = false
              this.getResumeList()
            } else {
              this.$message.error('保存失败')
            }
          })

        }
      })
    },
    handleWorkNatureChange() {
      if (this.preferenceForm.work_nature === 1) {
        this.preferenceForm.internship_duration = ''
        this.preferenceForm.weekly_attendance_days = ''
      }
    },

    handleDeletePreference() {
      this.$confirm('确定删除求职偏好吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.preferenceForm = {
          id: this.resumeDetail.id,
          desired_position: '',
          desired_industry: '',
          work_nature: '',
          internship_duration: '',
          weekly_attendance_days: '',
          arrival_time: '',
          desired_city: ''
        }

        addResumeBasicInfo(this.preferenceForm).then(async res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功')
            this.preferenceShow = false
            this.getResumeList()
          } else {
            this.$message.error('删除失败')
          }
        })
      })

    },

    handleSummary() {
      this.summaryShow = true
      this.summaryForm = {
        id: this.resumeDetail.id,
        personal_summary: this.resumeDetail.personal_summary
      }
    },

    handleCancelSummary() {
      this.summaryShow = false
      this.summaryForm = {
        id: '',
        personal_summary: ''
      }
      this.$refs.summaryFormRef.resetFields()
    },

    handleSaveSummary() {
      this.$refs.summaryFormRef.validate(async (valid) => {
        if (valid) {
          addResumeBasicInfo(this.summaryForm).then(async res => {
            if (res.data.code === 1) {
              this.$message.success('保存成功')
              this.summaryShow = false
              this.getResumeList()
            } else {
              this.$message.error('保存失败')
            }
          })
        }
      })
    },
  }
};
</script>

<style scoped lang="scss">
$primary-color: #B16EF9;
$shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);

.w100 {
  width: 100% !important;
}

.resume-manage-container {
  background-color: rgba(255, 255, 255, 1);
  background: url(../assets/img/dash_1x.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-content {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding-top: 100px;
  padding-left: 44px;
  padding-right: 44px;
  padding-bottom: 20px;

  // 侧边栏
  .sidebar {
    position: sticky;
    top: 0;
    margin-right: 24px;
    width: 15.5%;
    min-width: 240px;
    height: 100%;
    border: 1px solid $primary-color;
    background: linear-gradient(339deg, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 0.2) 98%);
    overflow-y: auto;
    box-shadow: $shadow;
    padding: 16px 24px;
    border-radius: 12px;

    .sidebar-header {
      .sidebar-header-title {
        font-size: 20px;
        font-weight: 600;
        line-height: normal;
        background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .mine-resume {
        margin-top: 28px;
        padding-bottom: 8px;
        border-bottom: 1px solid #acacbf;

        .mine-resume-title {
          font-size: 16px;
          color: #656587;
        }
      }
    }
  }

  // 简历分类
  .resume-category {
    flex: 1;
    display: flex;

    .category-list {
      flex: 1;
      overflow-y: auto;
      padding-right: 20px;

      &::-webkit-scrollbar {
        width: 6px;
        background: #a9aabd;
        border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: linear-gradient(to bottom, #7EB4EB 0%, #B16EF9 100%);
        border-radius: 6px;
      }

      .category-item {
        .category-header {
          display: flex;
          align-items: center;
          padding: 10px 0;

          .name {
            cursor: pointer;
            min-width: 100px;
            margin-right: 20px;
            font-size: 20px;
            font-weight: 600;
            background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }

          .delete-icon {
            cursor: pointer;
            font-size: 20px;
            color: rgba(101, 101, 135, 0.5);
            margin-right: 8px;

            &:hover {
              color: #B16EF9;
            }
          }

          .line {
            flex: 1;
            border-bottom: 1px dashed #B16EF9;
          }
        }

        .resume-list {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;

          .resume-item {
            display: flex;
            flex-direction: column;
            padding: 24px 16px 12px;
            width: 220px;
            min-height: 120px;
            border: 1px solid $primary-color;
            background: linear-gradient(180deg, rgba(177, 110, 249, 0.1) -3%, rgba(126, 180, 235, 0.1) 100%);
            box-shadow: $shadow;
            border-radius: 16px;

            .item-header {
              display: flex;
              align-items: center;

              .name {
                flex: 1;
                font-size: 16px;
                font-weight: 600;
                color: #656587;
              }

              .preview-icon {
                cursor: pointer;

                &:hover {
                  opacity: 0.8;
                }
              }
            }

            .item-content {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;

              .time {
                font-size: 14px;
                color: #656587;
              }

              .date {
                font-size: 14px;
                color: #656587;
              }

              .item-content-bottom {
                margin-top: 4px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .tags {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 2px;
                  max-width: 100%;
                }

                .tag {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 10px;
                  padding: 0 8px;
                  min-width: 60px;
                  height: 20px;
                  font-size: 12px;
                  color: #656587;
                  background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
                  white-space: nowrap;
                  word-break: keep-all;
                }

                .action {
                  display: flex;
                  align-items: center;

                  .edit-icon,
                  .delete-icon {
                    cursor: pointer;
                    width: 16px;
                    margin-left: 3px;

                    &:hover {
                      opacity: 0.8;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .action-button {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-left: 80px;
      padding-bottom: 32px;

      .add-category,
      .add-resume {
        margin-bottom: 12px;
        cursor: pointer;
        width: 140px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(286deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0.6) 99%);
        backdrop-filter: blur(30px);
        box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 20px;

        span {
          font-size: 20px;
          font-weight: 600;
          background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
      }

      .back {
        border-radius: 20px;
        cursor: pointer;
        width: 140px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) -3%, rgba(126, 180, 235, 0.6) 100%);
        backdrop-filter: blur(30px);
        box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);

        span {
          font-size: 20px;
          font-weight: 600;
          color: #fff;
        }
      }
    }
  }

  // 简历详情
  .resume-content {
    display: flex;
    padding: 12px 32px;
    flex: 1;
    border-radius: 14px;
    background: linear-gradient(300deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0.6) 99%);
    box-sizing: border-box;
    border: 1px solid #e9dbfa;
    box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
      background: #a9aabd;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #7EB4EB 0%, #B16EF9 100%);
      border-radius: 6px;
    }

    .resume-content-box {
      flex: 1;
      padding-right: 24px;

      .resume-header {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;

        .title {
          cursor: pointer;
          font-size: 18px;
          font-weight: 600;
          color: #656587;
          min-width: 160px;
        }

        .tags-container {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px 24px;
          max-width: 100%;

          .tags {
            display: flex;
            align-items: center;
            min-width: 120px;

            .label {
              font-size: 14px;
              font-weight: 500;
              color: #656587;
            }

            .value {
              cursor: pointer;
              font-size: 20px;
              font-weight: 600;
              background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;

            }

            .tags-value {
              display: flex;
              flex-wrap: wrap;
              gap: 4px 6px;
              max-width: 400px;

              .tag {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                font-weight: normal;
                min-width: 60px;
                height: 20px;
                font-size: 12px;
                color: #656587;
                background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
                padding: 0 8px;
                white-space: nowrap;
                word-break: keep-all;
              }
            }
          }
        }

      }

      .line {
        margin-top: 14px;
        height: 2px;
        width: 100%;
        background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
      }

      .resume-wrap {

        .resume-user-info {
          margin-top: 14px;
          display: flex;
          align-items: center;

          .avatar {
            width: 120px;
            height: 120px;
            box-shadow: 5px 5px 5.3px 0px rgba(0, 0, 0, 0.15);
            border-radius: 50%;
            margin-right: 20px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }

          .user-info {
            padding: 10px 20px;
            flex: 1;
            position: relative;

            .action {
              position: absolute;
              right: 0;
              top: 10px;
              display: flex;
              cursor: pointer;
              font-size: 14px;
              background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }


            .name-gender {
              display: flex;
              align-items: center;
              margin-bottom: 16px;

              .name {
                font-size: 28px;
                font-weight: 600;
                color: #000000;
                margin-right: 24px;
              }

              .gender {
                width: 32px;
                height: 32px;
              }
            }

            .info-flex {
              display: flex;
              flex-wrap: wrap;
              gap: 8px 48px;

              .prev-line {
                font-size: 20px;
                font-weight: 500;
                color: #656587;
              }
            }
          }

          .resume-user-info-edit {
            flex: 1;
            padding: 16px 16px 16px 36px;
            background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
            border-radius: 12px;

            ::v-deep {

              .el-input__inner,
              .el-textarea__inner,
              .el-form-item__label {
                color: #656587;
              }

              .el-input.is-active .el-input__inner,
              .el-input__inner:focus,
              .el-textarea__inner:focus {
                border-color: #9890F2;
              }
            }

            .edit-footer {
              display: flex;
              justify-content: flex-end;

              // .cancel-btn {
              //   background: #f9f9f8;
              //   color: #656587;
              //   border: 1px solid #9890F2;
              // }

              // .save-btn {
              //   background: #9890F2;
              //   color: #fff;
              //   border: none;
              // }
            }
          }
        }

        .school-wrap {
          .school-info {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .school-name {
              min-width: 200px;
              font-size: 20px;
              font-weight: 600;
              color: #000000;
              margin-bottom: 8px;
            }

            .school-period {
              display: flex;
              align-items: center;
              font-size: 18px;
              color: #656587;
              margin-bottom: 8px;
            }
          }

          .school-attr-list {
            display: flex;
            align-items: center;

            .school-attr-item {
              font-size: 14px;
              color: #656587;
              line-height: 24px;

              &.school-gpa {
                margin-left: 36px;
              }
            }

            .school-attr-line {
              width: 1px;
              margin: 0 12px;
              height: 16px;
              background-color: #656587;
            }
          }

          .school-courses {
            margin-top: 8px;
            font-size: 14px;
            color: #656587;
            line-height: 20px;
          }
        }
      }
    }

    .resume-sider {
      position: sticky;
      top: 0;
      margin-left: 24px;

      .resume-sider-box {
        padding: 16px 12px;
        width: 240px;
        border-radius: 14px;
        border: 1px solid $primary-color;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.2) -5%, rgba(126, 180, 235, 0.2) 100%);
        box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);

        .resume-sider-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            font-size: 20px;
            font-weight: 600;
            color: #656587;
          }

          .action {
            cursor: pointer;
            font-size: 14px;
            background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
        }

        .resume-module {
          margin-top: 16px;

          .resume-module-item {
            cursor: pointer;
            font-size: 18px;
            color: #656587;
            text-align: center;
            line-height: 18px;
            transition: all 0.3s ease;
            padding: 8px 12px;
            border-radius: 6px;

            &:hover {
              color: #fff;
              background: linear-gradient(180deg, rgba(177, 110, 249, 0.3) 0%, rgba(126, 180, 235, 0.3) 100%);
              transform: translateY(-2px);
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          .resume-module-line {
            margin: 10px 8px;
            height: 1px;
            background: #656587;
          }
        }

        .annex-resume-list {
          .annex-resume-item {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item-name {
              display: flex;
              align-items: center;

              .name-text {
                margin-left: 6px;
                font-size: 14px;
                color: #656587;
              }
            }

            .close-icon {
              font-size: 16px;
              color: #656587;
            }
          }
        }
      }

      .annex-resume {
        margin-top: 20px;
        background: linear-gradient(180deg, rgba(177, 110, 249, 0.1) -3%, rgba(126, 180, 235, 0.1) 100%);
      }

      .action-button {
        margin-top: 36px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        margin-left: 80px;

        .save-button {
          margin-bottom: 14px;
          cursor: pointer;
          width: 140px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) -3%, rgba(126, 180, 235, 0.6) 100%);
          backdrop-filter: blur(30px);
          box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
          border-radius: 24px;

          span {
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }
  }
}


.add-resume-btn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;

  .add-resume-btn {
    cursor: pointer;
    width: 144px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(126, 180, 235, 0.6) 0%, rgba(177, 110, 249, 0.6) 100%);
    margin-bottom: 20px;

    span {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
  }
}

.preference,
.summary {
  padding: 18px 0 18px 12px;

  .preference-title,
  .summary-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .m-l {
      display: flex;
      align-items: center;

      .icon {
        width: 26px;
        height: 26px;
        margin-right: 12px;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #656587;
      }
    }

    .m-r {
      cursor: pointer;
      display: flex;
      width: 20px;
      height: 20px;

      .add-icon {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .preference-data-wrap,
  .summary-data-wrap {
    position: relative;
    cursor: pointer;
    padding-left: 36px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 12px;

    &:hover {
      // background: linear-gradient(180deg, rgba(177, 110, 249, 0.2) -5%, rgba(126, 180, 235, 0.2) 100%);
      background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
    }

    .summary-content {
      margin-top: 16px;
      font-size: 14px;
      color: #656587;
      line-height: 20px;
    }

    .preference-name {
      min-width: 200px;
      margin-right: 32px;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 8px;
    }

    .preference-data-item {
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      font-size: 14px;
      color: #656587;
      line-height: 20px;
      margin-right: 20px;

      .line {
        width: 1px;
        height: 16px;
        background: #656587;
        margin: 0 12px;
      }
    }

    .action {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 5px;

      img {
        width: 16px;
        margin-left: 8px;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .delete-icon {
      position: absolute;
      top: 8px;
      right: 5px;
      display: flex;

      img {
        width: 16px;
        margin-left: 8px;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .preference-form,
  .summary-form {
    background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
    border-radius: 12px;
    padding: 16px 16px 16px 36px;
    margin-top: 16px;

    .preference-form-title,
    .summary-form-title {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .preference-form-footer,
    .summary-form-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }
}

.select-resume-dialog-content {
  .category-list {
    flex: 1;
    overflow-y: auto;
    padding-right: 20px;

    &::-webkit-scrollbar {
      width: 6px;
      background: #a9aabd;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #7EB4EB 0%, #B16EF9 100%);
      border-radius: 6px;
    }

    .category-item {
      .category-header {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .name {
          cursor: pointer;
          min-width: 100px;
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
          background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }

        .line {
          flex: 1;
          border-bottom: 1px dashed #B16EF9;
        }
      }

      .resume-list {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        .resume-item {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          padding: 24px 16px 12px;
          width: 220px;
          min-height: 120px;
          border: 1px solid $primary-color;
          background: linear-gradient(180deg, rgba(177, 110, 249, 0.1) -3%, rgba(126, 180, 235, 0.1) 100%);
          box-shadow: $shadow;
          border-radius: 16px;
          transition: all 0.3s ease;

          &:hover {
            background: linear-gradient(180deg, rgba(177, 110, 249, 0.2) -3%, rgba(126, 180, 235, 0.2) 100%);
          }

          .item-header {
            display: flex;
            align-items: center;

            .name {
              flex: 1;
              font-size: 16px;
              font-weight: 600;
              color: #656587;
            }

          }

          .item-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            .time {
              font-size: 14px;
              color: #656587;
            }

            .date {
              font-size: 14px;
              color: #656587;
            }

            .item-content-bottom {
              margin-top: 4px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .tags {
                flex: 1;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 2px;
                max-width: 100%;
              }

              .tag {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                padding: 0 8px;
                min-width: 60px;
                height: 20px;
                font-size: 12px;
                color: #656587;
                background: linear-gradient(180deg, rgba(177, 110, 249, 0.6) 0%, rgba(126, 180, 235, 0.6) 100%);
                white-space: nowrap;
                word-break: keep-all;
              }

              .action {
                display: flex;
                align-items: center;

                .edit-icon,
                .delete-icon {
                  cursor: pointer;
                  width: 16px;
                  margin-left: 3px;

                  &:hover {
                    opacity: 0.8;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}


::v-deep .resume-module-manager:last-child {
  border: none;
}

::v-deep .el-dialog {
  border-radius: 20px;
  border: 1px solid #B16EF9;
}

::v-deep .el-dialog__header {
  display: flex;
}

::v-deep .el-dialog__body {
  padding-bottom: 10px;
}

::v-deep .el-dialog__title {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-weight: 600;
}
</style>